@if (dashboardViewModel) {
  <section aria-label="Synthèse de l'offre">
    @if (dashboardViewModel?.megapush) {
      <megapush
        [cid]="dashboardViewModel.megapush?.cid"
        [energy]="dashboardViewModel.megapush?.energy"
        [img161]="dashboardViewModel.megapush?.img161"
        [img162]="dashboardViewModel.megapush?.img162"
        [legal]="dashboardViewModel.megapush?.legal"
        [tag]="dashboardViewModel.megapush?.tag"
        [text]="dashboardViewModel.megapush?.text"
        [text2]="dashboardViewModel.megapush?.text2"
        [textColor]="dashboardViewModel.megapush?.textColor"
        [trackingData]="dashboardViewModel.megapush?.trackingData"
        [title]="dashboardViewModel.megapush?.title"
        [urlLabel]="dashboardViewModel.megapush?.urlLabel"
        [urlWeb]="dashboardViewModel.megapush?.urlWeb"
      >
      </megapush>
    }
    <div class="main-content-full-width">
      <div class="row">
        <div class="col-12 mb-1">
          @if (dashboardViewModel?.forbidden) {
            <forbidden
              [forbiddenType]="dashboardViewModel.forbidden.clientType"
              [viewModel]="dashboardViewModel.forbidden"
            >
            </forbidden>
          }
          @for (section of dashboardViewModel?.sections; track section; let i = $index) {
            <div class="anchor mt-2" id="{{ section.id }}" data-e2e="dashboardsection">
              <div class="mb-2">
                @if (section.offer?.migrationLabel) {
                  <h2
                    class="p-0 m-0 no-signature"
                    data-e2e="section-offer-migration-label"
                    [innerHTML]="section.offer?.migrationLabel | insecable"
                  ></h2>
                }
                <h1 class="h2 p-0 m-0 no-signature" data-e2e="section-offer-type">
                  @if (getIcon(section)) {
                    <img alt="" class="mr-1" data-e2e="item-brand-picto" src="{{ getIcon(section) }}" />
                  }
                  {{ section.offer.name }}
                </h1>
                @if (getIcon(section)) {
                  <div class="alert-container additional-message mt-1">
                    <p class="alert">
                      <span class="ob1-alert-title">{{ MessageMixed }}</span>
                    </p>
                  </div>
                }
                @if (section.message) {
                  <div [ngClass]="{ 'pt-1': MessageMixed === null }">
                    <span class="lead"
                      ><strong>{{ section.message }}</strong></span
                    >
                  </div>
                }
                @if (section.offer) {
                  <ecm-tags-infos [offer]="section.offer"></ecm-tags-infos>
                }
                @if (dashboardViewModel?.alerts) {
                  <push-alerts
                    [alerts]="dashboardViewModel.alerts"
                    [isMobile]="this.isMobile"
                    [isSoshBrand]="this.isSoshBrand()()"
                  ></push-alerts>
                }
                @if (dashboardViewModel?.warnings) {
                  <push-warnings
                    [warnings]="dashboardViewModel.warnings"
                    [isMobile]="this.isMobile"
                    [isSoshBrand]="this.isSoshBrand()()"
                  ></push-warnings>
                }
                @if (dashboardViewModel?.infos) {
                  <push-helps
                    [infos]="dashboardViewModel.infos"
                    [isMobile]="this.isMobile"
                    [isSoshBrand]="this.isSoshBrand()()"
                  ></push-helps>
                }
                @if (dashboardViewModel?.relational) {
                  <relational-recommendation [viewModel]="dashboardViewModel.relational"></relational-recommendation>
                }
                @if (dashboardViewModel?.whoUsesIt) {
                  <push-who-uses-it
                    [push]="dashboardViewModel.whoUsesIt"
                    [isMobile]="this.isMobile"
                    [isSoshBrand]="this.isSoshBrand()()"
                  ></push-who-uses-it>
                }
              </div>
              <ul class="items-list row">
                @if (section.lastBill; as bill) {
                  <li class="col-12">
                    <ecm-section-bill [bill]="bill" [offer]="section.offer"></ecm-section-bill>
                  </li>
                }
                <li class="col-12">
                  @if (section.offer && section.offer.link) {
                    <ecm-section-offer [offer]="section.offer"></ecm-section-offer>
                  }
                </li>
                <li class="col-12">
                  @if (section.changeOffer; as changeOffer) {
                    <push-change-offer
                      [changeOffer]="changeOffer"
                      [zid]="zid"
                      [isDisabledEclair]="true"
                      [offer]="section.offer"
                    ></push-change-offer>
                  }
                </li>
              </ul>
              <hr class="separator separator--large separator--gray2" />
              @for (item of section?.itemsSim; track item; let isFirst = $first; let isLast = $last) {
                <item
                  data-e2e="item"
                  [offer]="section.offer"
                  [viewModel]="item"
                  [multiSim]="section.itemMultiSim"
                  [changeMobile]="section.changeMobile"
                  [universe]="dashboardViewModel?.universe"
                  [first]="isFirst"
                  [last]="isLast"
                  [optionsMobile]="section?.options?.optionsMobile"
                  [isMobile]="this.isMobile"
                ></item>
              }
              @if (section?.commercialPush?.simPush) {
                <push-commercial
                  [commercialPush]="section?.commercialPush?.simPush"
                  [isMobile]="this.isMobile"
                  [isSoshBrand]="this.isSoshBrand()"
                ></push-commercial>
              }
              @if (isMobileWidth()) {
                <hr class="separator separator--large separator--gray2" />
              }
              @for (item of section?.itemsHome?.items; track item; let isFirst = $first; let isLast = $last) {
                <item
                  data-e2e="item"
                  [offer]="section.offer"
                  [viewModel]="item"
                  [sectionHome]="section.itemsHome.section"
                  [help]="section.itemHelp"
                  [universe]="dashboardViewModel?.universe"
                  [first]="!isFirst"
                  [last]="isLast"
                  [isMobile]="this.isMobile"
                  [internetStatus]="internetStatus"
                  [wifiStatus]="wifiStatus"
                  [voipStatus]="voipStatus"
                  (itemActionEvent)="doAction($event)"
                ></item>
              }
              @if (section?.commercialPush?.homePush) {
                <push-commercial
                  [commercialPush]="section?.commercialPush?.homePush"
                  [isMobile]="this.isMobile"
                  [isSoshBrand]="this.isSoshBrand()"
                ></push-commercial>
              }
              @if (isMobileWidth()) {
                <hr class="separator separator--large separator--gray2" />
              }
              @for (item of section?.itemsEntertainment; track item; let isFirst = $first; let isLast = $last) {
                <item
                  data-e2e="item"
                  [offer]="section.offer"
                  [viewModel]="item"
                  [universe]="dashboardViewModel?.universe"
                  [first]="isFirst"
                  [last]="isLast"
                  [optionsTv]="section?.options?.optionsTv"
                  [isMobile]="this.isMobile"
                  [tvStatus]="tvStatus"
                  (itemActionEvent)="doAction($event)"
                ></item>
              }
              @if (section?.commercialPush?.entertainmentPush) {
                <push-commercial
                  [commercialPush]="section?.commercialPush?.entertainmentPush"
                  [isMobile]="this.isMobile"
                  [isSoshBrand]="this.isSoshBrand()"
                ></push-commercial>
              }
              @for (item of section?.itemsCybersecure; track item; let isFirst = $first; let isLast = $last) {
                <item
                  data-e2e="item"
                  [offer]="section.offer"
                  [viewModel]="item"
                  [universe]="dashboardViewModel?.universe"
                  [first]="isFirst"
                  [last]="isLast"
                  [isMobile]="this.isMobile"
                  (itemActionEvent)="doAction($event)"
                ></item>
              }
            </div>
          }
          @if (dashboardViewModel.sharedServices.length !== 0) {
            @if (isMobileWidth()) {
              <hr class="separator separator--large separator--gray2" />
            }
            <sharedservices
              [viewModels]="dashboardViewModel?.sharedServices"
              [isNsru]="dashboardViewModel?.isSharedServicesNsru"
            ></sharedservices>
          }
        </div>
      </div>
    </div>
  </section>
} @else {
  <section class="apply-one-style" aria-label="Synthèse de l'offre">
    <div class="site-width">
      <div class="container-fluid">
        <div class="py-5" data-e2e="spinner">
          <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
        </div>
      </div>
    </div>
  </section>
}
